import { h, Fragment } from "preact";

import {


	Divider,
	Stack,
	Typography,
} from "@mui/material";

import FormField from "../Common/FormField";

import FormToggle from "../Common/FormToggle";


// function TabPanel(props) {
// 	const { children, value, index, ...other } = props;

// 	return (
// 		<div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
// 			{value === index && (
// 				<Box p={3}>
// 					<Typography>{children}</Typography>
// 				</Box>
// 			)}
// 		</div>
// 	);
// }
export default function Terrain({ upperState, upperHandleChange }) {

	const handleChange = (event) => {

		upperHandleChange(event);
	};

	return (
		<Stack spacing={1}>
			<FormField upperState={upperState} id="surface" placeholder="Surface du terrain en m2" handleChange={handleChange} num={true} disabled={upperState.mandate_signed} helper={<Stack><Typography>Indiquer la surface du terrain/jardin</Typography></Stack>} />

			<Divider />
			<FormToggle upperState={upperState} id="constructible" handleChange={handleChange} />
			{/* <Divider /> */}
			{/* <FormToggle upperState={upperState} id="co_property_asl" handleChange={handleChange} helper={<Stack><Typography>ASL</Typography></Stack>} /> */}
		</Stack>
	);
}
